/** @type {import('vue-router').RouterOptions['routes']} */

import {
    HELP_PAGE_CLASSIFICATION,
    HELP_URL_LOGIN,
    HELP_URL_ADD_TEAM_MEMBER,
    HELP_URL_BILLING,
    HELP_URL_UPLOAD_DOCUMENT,
    HELP_URL_EDIT_DOCUMENT_EXTRACTIONS,
} from "../utils/wizards"

export const routes = [
    // HOME
    // We use this redirect so we can generally point a link to "home" and decide here
    //  to which view it should redirect.
    {
        path: "",
        name: "home",
        // TODO: redirect to dashboard once available
        redirect: { name: "documents-list" },
    },
    // LOGIN & REGISTRATION
    {
        path: "/login",
        name: "login",
        component: () => import("/src/views/LoginView.vue"),
        props: (route) => ({
            alertQueryMessage: route.query.alert,
        }),
        meta: {
            requiresAuth: false,
            requiresAnonymous: true,
            metaTags: {
                name: "description",
                content:
                    "Log into Evolution AI’s acclaimed Financial Statements AI platform.",
            },
            helpUrl: HELP_URL_LOGIN,
        },
    },
    {
        path: "/register",
        name: "self-service-registration",
        component: () => import("/src/views/UserRegistrationView.vue"),
        props: (route) => ({
            email: route.query.email,
        }),
        meta: {
            requiresAuth: false,
            requiresAnonymous: true,
            metaTags: {
                name: "description",
                content:
                    "Register Evolution AI’s acclaimed Financial Statements AI platform.",
            },
        },
    },
    {
        path: "/setup",
        name: "complete-registration",
        component: () => import("/src/views/UserSetupView.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/inactive-user",
        name: "inactive-user",
        component: () => import("/src/views/InactiveUserView.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/mobile-unsupported",
        name: "mobile-unsupported",
        component: () => import("/src/views/MobileUnsupportedView.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    // // DASHBOARD VIEWS
    // {
    //     path: "/dashboard",
    //     name: "dashboard",
    //     component: () => import("/src/dashboard/views/DashboardMain.vue"),
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
    // DOCUMENTS VIEWS
    {
        path: "/documents",
        component: () => import("/src/views/DocumentListView.vue"),
        name: "documents-list",
        meta: {
            requiresAuth: true,
            crumbs: [{ name: "Documents", to: { name: "documents-list" } }],
            helpUrl: HELP_URL_UPLOAD_DOCUMENT,
        },
    },
    {
        path: "/documents/:id",
        name: "document-view",
        component: () => import("/src/views/DocumentView.vue"),
        props: (route) => ({
            documentId: route.params.id,
            // pageNumber: parseInt(route.query?.p || 0),
        }),
        meta: {
            requiresAuth: true,
            crumbs: [
                { name: "Documents", to: { name: "documents-list" } },
                { name: "%document" },
            ],
            helpUrl: HELP_URL_EDIT_DOCUMENT_EXTRACTIONS,
        },
    },
    // {
    //     path: "/documents/:id/annotate",
    //     name: "annotate-document",
    //     component: () => import("/src/documents/views/AnnotateView.vue"),
    //     props: (route) => ({
    //         documentId: route.params.id,
    //         subdocumentIdx:
    //             "subdocument" in route.query
    //                 ? parseInt(route.query.subdocument)
    //                 : -1,
    //     }),
    //     meta: {
    //         requiresAuth: true,
    //         crumbs: [
    //             { name: "Documents", to: { name: "documents-list" } },
    //             { name: "%document" },
    //             { name: "Annotate" },
    //         ],
    //     },
    // },
    {
        path: "/documents/:id/edit-pages",
        name: "classify-pages",
        component: () => import("/src/views/PageClassificationView.vue"),
        props: (route) => ({
            documentId: route.params.id,
        }),
        meta: {
            requiresAuth: true,
            crumbs: [
                { name: "Documents", to: { name: "documents-list" } },
                { name: "%document" },
                { name: "Edit pages" },
            ],
            helpUrl: HELP_PAGE_CLASSIFICATION, // link to help wizard for help button
        },
    },
    // DOCUMENT TYPES VIEWS
    {
        path: "/settings/structured-data-fields",
        name: "document-types",
        component: () => import("/src/views/DocumentTypesView.vue"),
        meta: {
            requiresAuth: true,
            crumbs: [{ name: "Settings" }, { name: "Structured data fields" }],
        },
    },
    // TEAM VIEWS
    {
        path: "/team",
        component: () => import("/src/views/TeamView.vue"),
        name: "team",
        meta: {
            requiresAuth: true,
            crumbs: [{ name: "Team" }],
            helpUrl: HELP_URL_ADD_TEAM_MEMBER,
        },
    },
    // // OUTPUT VIEWS
    // {
    //     path: "/output",
    //     component: () => import("/src/output/views/OutputTemplate.vue"),
    //     name: "output",
    //     meta: {
    //         requiresAuth: true,
    //         crumbs: [{ name: "Output" }],
    //     },
    // },
    // // BILLING VIEW
    {
        path: "/billing",
        component: () => import("/src/views/BillingView.vue"),
        name: "billing",
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            crumbs: [{ name: "Billing" }],
            helpUrl: HELP_URL_BILLING,
        },
    },
    {
        path: "/billing-required",
        name: "billing-required",
        component: () => import("/src/views/BillingRequiredView.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/billing/confirmation",
        name: "billing-spinner",
        component: () => import("/src/views/BillingSpinnerView.vue"),
        meta: {
            requriresAuth: true,
        },
    },
    // ORGANIZATION SETTINGS VIEW
    {
        path: "/settings",
        component: () => import("/src/views/OrganizationSettingsView.vue"),
        name: "settings",
        meta: {
            requiresAuth: true,
            requiresSuperAdmin: true,
            crumbs: [{ name: "Settings" }],
        },
    },
    // // AUDIT LOG VIEW
    // {
    //     path: "/audit-log",
    //     component: () => import("/src/audit-log/views/AuditLogMain.vue"),
    //     name: "audit-log",
    //     meta: {
    //         requiresAuth: true,
    //         crumbs: [{ name: "Audit Log" }],
    //     },
    // },
    // // API DOCUMENTATION
    // {
    //     path: "/api-documentation",
    //     component: () => import("/src/api-documentation/views/ApiMain.vue"),
    //     name: "api-documentation",
    //     meta: {
    //         requiresAuth: true,
    //         crumbs: [{ name: "API documentation" }],
    //     },
    // },
    // OTHER VIEWS
    {
        path: "/error/:code(\\d{3})?",
        name: "error",
        component: () => import("/src/components/core/Error.vue"),
        meta: {
            requiresAuth: false,
        },
        props: (route) => ({
            code: parseInt(route?.params?.code ?? 500),
        }),
    },
    {
        // Match any other url and redirect to 404
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: () => import("/src/components/core/Error.vue"),
        meta: {
            requiresAuth: false,
        },
        props: () => ({
            code: 404,
            title: "Page Not Found",
            message:
                "The page you are trying to access does not exist, have you typed a correct URL?",
        }),
    },
]
